module.exports = __webpack_public_path__ + "img/icon_fire_disabled.svg";